window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "validatedByComPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};